<template>
    <div class="w-full h-full">
        <GmapMap
            :center="{lat:48.172705, lng:17.143032}"
            :options="mapStyles"
            :zoom="17"
            style="width: 100%; height: 100%"
        >
            <GmapMarker
                :position="{lat:48.172705, lng:17.143032}"
            ></GmapMarker>
        </GmapMap>
    </div>
</template>

<script>
export default {
    name: 'Map',
    data() {
        return {
            mapStyles: {
                styles: [
                    {elementType: 'geometry', stylers: [{color: '#494949'}]},
                    {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                    {
                        featureType: 'administrative.locality',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#d59563'}],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#000000'}],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.stroke',
                        stylers: [{color: '#d9d9d9'}],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'geometry',
                        stylers: [{color: '#263c3f'}],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#6b9a76'}],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.stroke',
                        stylers: [{color: '#000000'}],
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [{color: '#ffffff'}],
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry.stroke',
                        stylers: [{color: '#212a37'}],
                    },
                    {
                        featureType: 'road',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#000000'}],
                    },
                    {
                        featureType: 'road',
                        elementType: 'labels.text.stroke',
                        stylers: [{color: '#ffffff'}],
                    },

                    {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [{color: '#ffffff'}],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry.stroke',
                        stylers: [{color: '#1f2835'}],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#000000'}],
                    },
                    {
                        featureType: 'transit',
                        elementType: 'geometry',
                        stylers: [{color: '#2f3948'}],
                    },
                    {
                        featureType: 'transit.station',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#d59563'}],
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry',
                        stylers: [{color: '#3f92ff'}],
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#515c6d'}],
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.stroke',
                        stylers: [{color: '#17263c'}],
                    },
                ],
            },
            markerStyles: {
                // url: 'http://maps.google.com/mapfiles/ms/icons/orange-dot.png',
            },

        };
    },
};
</script>

<style>
.vue-map {
    height: 100%;
    width: 100%;
}
</style>
